const IconAlert = function() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-alert" viewBox="0 0 24 24"><path d="M11.95 1.6c-.4 0-.74.22-.94.56L.15 20.96c-.44.77.11 1.72 1 1.72h21.7c.89 0 1.44-.95 1-1.71L12.99 2.16a1.14 1.14 0 0 0-1.04-.57ZM12 5l-3.93 6.65-4.96 8.75z"/></svg>
	);
}

export default IconAlert;